export const rtcPipelineType = "rtc";
export const telemetryPipelineType = "telemetry";

export type IStreamControl =
    | IRtcStreamControl
    | ITelemetryStreamControl
    | IDegradeVideoStreamControl
    | IAudioStreamControl
    | ISetLowBandwidthMode;
export interface IStreamControlBase {
    streamName: string;
}
export interface IRtcStreamControl extends IStreamControlBase {
    pipeline: typeof rtcPipelineType;
    enable: boolean;
}
export interface ITelemetryStreamControl extends IStreamControlBase {
    pipeline: typeof telemetryPipelineType;
    enablePriorityUpload: boolean;
}

export interface IDegradeVideoStreamControl extends IStreamControlBase {
    degradeVideoQuality: boolean;
}

export interface IAudioStreamControl extends IStreamControlBase {
    setAudioFormat: string;
}

export interface ISetLowBandwidthMode extends IStreamControlBase {
    setLowBandwidthMode: boolean;
}
